import {
	formatDate,
	formatDateTime,
} from '../../utils/intl';
import Highcharts from 'highcharts/highstock';

const numberFormatter = (number, decimals) => Highcharts.numberFormat(number, decimals);

const tooltipHeader = (date, showTime) => {
	const formattedDate = showTime ? formatDateTime(date) : formatDate(date);

	return `
	<div class="chart-tooltip">
		<div class="chart-tooltip__header">${formattedDate}</div>
	`;
};

const tooltipPointLabel = (series) => {
	const { userOptions: { className } } = series;
	const colorClass = className ? className : `highcharts-color-${series.colorIndex}`;

	return `
		<span class="chart-tooltip__label">
			<span class="chart-tooltip__indicator ${colorClass}"></span>
			${series.name}:
		</span>
	`;
};

const tooltipPoint = (point, series, decimals) => `
	<div class="chart-tooltip__point">
		${tooltipPointLabel(series)}
		<span class="chart-tooltip__value">${numberFormatter(point.y, decimals)}</span>
	</div>
`;

const tooltipPointOHLC = (point, series, decimals) => `
	<div class="chart-tooltip__point">
		${tooltipPointLabel(series)}
		<div class="chart-tooltip__value">O: ${numberFormatter(point.open, decimals)}</div>
		<div class="chart-tooltip__value">H: ${numberFormatter(point.high, decimals)}</div>
		<div class="chart-tooltip__value">L: ${numberFormatter(point.low, decimals)}</div>
		<div class="chart-tooltip__value">C: ${numberFormatter(point.close, decimals)}</div>
	</div>
`;

const tooltipFooter = '</div>';

const tooltipFormat = (data, showTime) => {
	const date = new Date(data.x);
	const header = tooltipHeader(date, showTime);

	const body = data.points.reduce((memo, point) => {
		const {
			series,
			series: { yAxis: { userOptions: { decimalPrecision } } },
		} = point;

		const { type } = series;
		const isOHLC = type === 'ohlc' || type === 'candlestick';
		const pointData = isOHLC ? point.point : point;

		const pointBody = isOHLC
			? tooltipPointOHLC(pointData, series, decimalPrecision)
			: tooltipPoint(point, series, decimalPrecision);

		return `${memo}${pointBody}`;
	}, '');

	const footer = tooltipFooter;

	return `
		${header}
		${body}
		${footer}
	`;
};

export default tooltipFormat;

